// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from './NoDataCell';
import { Tooltip } from '../tooltips';
import ComparisonItem from '@/types/comparison-item';

type Props = {
  value?: string | number;
  className?: string;
  disclaimer?: string;
  item?: ComparisonItem;
  tooltipMessage?: string;
  color?: string;
};

const CorrelationMatrixDataCell: React.FunctionComponent<Props> = ({ value, className, disclaimer, item, tooltipMessage, color }: Props) => {
  if (value == null) {
    return <NoDataCell disclaimerKey={disclaimer} item={item} />;
  }

  if (value === '') {
    return <div className={classNames('cell correlation-matrix-data-cell', className)}>{'\u200B'}</div>; // Zero-width space to ensure empty cells have a value
  }

  const style = {
    color,
  };

  return (
    <div className={classNames('cell correlation-matrix-data-cell', className)} style={style}>
      <Tooltip disabled={!tooltipMessage} message={tooltipMessage}>
        <span>{value}</span>
      </Tooltip>
    </div>
  );
};

export default CorrelationMatrixDataCell;
